import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigation } from "react-router-dom";
import "./topLoader.css";

function TopLoader() {
  const location = useLocation();
  const navigation = useNavigation();
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);
  const hideTimerRef = useRef(null);
  const previousPathRef = useRef(location.pathname);

  const start = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    setVisible(true);
    setProgress(8);
    intervalRef.current = setInterval(() => {
      setProgress((current) => {
        if (current >= 90) return current;
        const increment = current < 30 ? 8 : current < 60 ? 4 : 2;
        return Math.min(current + increment, 90);
      });
    }, 200);
  };

  const finish = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setProgress(100);
    hideTimerRef.current = setTimeout(() => {
      setVisible(false);
      setProgress(0);
    }, 350);
  };

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      previousPathRef.current = location.pathname;
      start();
      const completeTimer = setTimeout(finish, 600);
      return () => clearTimeout(completeTimer);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (navigation.state === "loading") {
      start();
    } else if (navigation.state === "idle" && visible) {
      finish();
    }
  }, [navigation.state]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="top-loader" aria-hidden="true">
      <div
        className="top-loader__bar"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}

export default TopLoader;
